<template>
  <div>
    <p>
      Redirecting...
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import authenticationService from "../services/authentication-service";

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();

    onMounted(async () => {      
      await authenticationService.handleRedirect();
      store.dispatch('auth/setUserAuthenticationStatus', true); 
      await router.push("/dashboard");
    });   

    return { };
  },
});
</script>


<style scoped></style>
